<template>
     <!--slider end -->
    <header class="header header-page">
      <div class="container">
        <div class="row">
          <nav class="navbar navbar-default">
            <div class="container-fluid">
              <!-- Brand and toggle get grouped for better mobile display -->
              <div class="navbar-header">
                <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                  <span class="sr-only">Toggle navigation</span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                </button>
                  <a class="navbar-brand" href="/">
                    <img src="/static/img/logo.png" alt="">
                  </a>
              </div>
              <!-- Collect the nav links, forms, and other content for toggling -->
              <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                <ul class="nav navbar-nav navbar-right">
                  <li><a href="/" v-lang.home></a></li>
                  <li class="dropdown">
                    <a href="#" v-lang.projects class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"> <span class="caret"></span></a>
                    <ul class="dropdown-menu">
                      <li><a href="/umbrella" v-lang.umbrellatext></a></li>
                      <li><a href="/engineering" v-lang.engneeringtext></a></li>
                    </ul>
                  </li>
                  <li><a href="/blogs" v-lang.blog></a></li>
                  <li><a href="/About"  v-lang.about></a></li>
                  <li><a href="/contact"  v-lang.contactus></a></li>
                  <div class="lang">
                    <ul>
                      <li :class="checkLang('ar')"><a @click="changeLang('ar')">AR</a></li>
                      <li class="between">/</li>
                      <li :class="checkLang('tr')"><a @click="changeLang('tr')">TR</a></li>
                      <li class="between">/</li>
                      <li :class="checkLang('en')"><a @click="changeLang('en')">EN</a></li>
                    </ul>
                  </div>
                  <!--<li><select  @change="changeLang" name="lang" id="lang">-->
                      <!--<option  v-for="lang in langs" :value="lang.code" :selected="selectedLang(lang.code)">{{lang.name}}</option>-->
                    <!--</select></li>-->
                </ul>
              </div><!-- /.navbar-collapse -->
            </div><!-- /.container-fluid -->
          </nav>
          <div class="col-md-4 col-xs-6 col-sm-6">
            <div class="logo-box">

            </div>
          </div>
          <div class="col-md-8 col-xs-6 col-sm-6 menu-header">

          </div>
          </div>
        </div>
    </header>

</template>
<script>
import {languages,currentLang} from '../../strings'
export default {
  data(){
    return {
      langs : languages
    }
  },
  methods: {
      checkLang(lan){
          if(this.language === lan)
            return 'active'
      },
     changeLang(lan){
       cl(window.location.href)
      this.language = lan
      redirect(window.location.href)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/Header.vue